import isOneSpecifierBeforeTheOther from './isOneSpecifierBeforeTheOther';
import { format } from 'owa-localize';
import { localizedFormatter } from './localizedFormatter';
import { getShortWeekDayFormat } from './formatShortWeekDay';
import { getLocalizedString } from 'owa-datetime-formatters-core';
import type { OwaDate, GlobalCalendarLocale } from 'owa-datetime';

/**
 * This ignores user settings and hardcodes an abbreviated month and the day without leading zeros.
 * This should be used in places where space is at a premium.
 * Common output is 'ddd, MMM d' or 'ddd, d MMM'.
 */
export function getShortWeekDayMonthDayFormat(dateFormat: string, _timeFormat: string): string {
    const dayFirst = isOneSpecifierBeforeTheOther(dateFormat, 'd', 'M');
    const formatString = getLocalizedString(
        dayFirst ? 'monthDayWeekDayFormatDayFirst' : 'monthDayWeekDayFormatMonthFirst'
    );
    return format(
        formatString,
        getShortWeekDayFormat(),
        getLocalizedString('MMM'),
        getLocalizedString('d')
    );
}

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    localizedFormatter(getShortWeekDayMonthDayFormat);
export default defaultExport;
